import instance from "../instance";
import axios from "axios";

export const authApi = {
  login: async (email, password) => {
    // todo old auth
    return instance.post(`/v1/login/access-token`, new URLSearchParams({username: email, password}), {
      headers: {
        accept: 'application/x-www-form-urlencoded',
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    })
    //return instance.post('/v1/login/email', {login: email, password, remember: true})
    // return instance.post(`/v1/login/email-form`, new URLSearchParams({username: email, password}), {
    //   headers: {
    //     accept: 'application/x-www-form-urlencoded',
    //     'Content-Type': 'application/x-www-form-urlencoded'
    //   }
    // })
  },
  register: (email, password) => {
    return instance.post(`/v1/users/open`, {email, password})
  },
  confirmEmail: (token) => {
    console.log('here')
    return instance.post(`/v1/confirm-email/`, `"${token}"`)
  },
  testToken: (token) => {
    return instance.post(`/v1/login/test-token`, null, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    })
  },
}
